import { useState, useEffect } from "react";
// import QrReader from "react-qr-reader";
import { useHistory } from "react-router-dom";
import firebase from "../firebase/firebase";
import { MyIcon } from "../styles/styles";

import scan from "../assets/scan.svg";
import off from "../assets/off.svg";
import plus from "../assets/plus.svg";
import minus from "../assets/minus.svg";
import triTop from "../assets/tri-top.svg";
import triLeft from "../assets/tri-left.svg";
import triRight from "../assets/tri-right.svg";
import triBottom from "../assets/tri-bottom.svg";
import remoteBottom from "../assets/remote-bottom.png";
import texture from "../assets/texture.png";
import textureDark from "../assets/texture-dark.png";

const getQueryParams = () =>
  window.location.search
    .replace("?", "")
    .split("&")
    .reduce(
      (r, e) => ((r[e.split("=")[0]] = decodeURIComponent(e.split("=")[1])), r),
      {}
    );

const getQrcode = (tempUrl) => {
  if (tempUrl) {
    return tempUrl.split("?")[1].split("=")[1];
  } else {
    return null;
  }
};

const RemoteApp = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(true); // IMP  byDefault should be true

  const [wait, setWait] = useState(false);
  // const [qrcodeScanned, setQrcodeScanned] = useState(false); // IMP  byDefault should be false
  const [qrcodeValue, setQrcodeValue] = useState("");

  const [channelNo, setChannelNo] = useState(null);

  const handleRemoteScan = () => {
    if (window.location.search) {
      const queryParams = getQueryParams();
      const qrcode = queryParams?.qrcode;
      if (qrcode) {
        handleScan(qrcode);
      }
    }
  };

  useEffect(() => {
    handleRemoteScan();
  }, []);

  // START scan
  const handleScan = async (qrcode) => {
    setLoading(true);
    setQrcodeValue(qrcode);
    try {
      await firebase.firestore().collection("tv_remote").doc(qrcode).update({
        channel_no: 1,
        scanned: true,
      });

      setTimeout(async () => {
        await firebase
          .firestore()
          .collection("tv_remote")
          .doc(qrcode)
          .update({ scanned: false });

        setLoading(false);
      }, 1000);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleOnAppScan = (data) => {
    if (!data) return;
    const qrcode = getQrcode(data);
    handleScan(qrcode);
  };

  const handleError = (err) => {
    console.log(err);
  };
  // END Scan

  const handleUpdateChannelNo = async (no) => {
    try {
      await firebase
        .firestore()
        .collection("tv_remote")
        .doc(qrcodeValue)
        .update({ channel_no: no });

      setChannelNo(null);
      setWait(false);
    } catch (error) {
      setChannelNo(null);
      setWait(false);
    }
  };

  // PART Remote buttons
  const handleResetScan = async () => {
    try {
      await firebase
        .firestore()
        .collection("tv_remote")
        .doc(qrcodeValue)
        .update({ remote_linked: null, scanned: false, control_key: null });

      setQrcodeValue("");
      // setQrcodeScanned(false);
      history.replace("/");
    } catch (error) {
      setQrcodeValue("");
      history.replace("/");
      // setQrcodeScanned(false);
    }
  };

  const handlePowerOff = async () => {
    try {
      await firebase
        .firestore()
        .collection("tv_remote")
        .doc(qrcodeValue)
        .update({ remote_linked: null, scanned: false, control_key: "OFF" });

      setQrcodeValue("");
      // setQrcodeScanned(false);
      history.replace("/");
    } catch (error) {
      setQrcodeValue("");
      // setQrcodeScanned(false);
      history.replace("/");
    }
  };

  // Number Pad buttons
  const handleNoClick = (no) => {
    // if (!qrcodeScanned) return;

    const newNo = channelNo ? channelNo + no : no;
    setChannelNo(newNo);

    setTimeout(() => {
      handleUpdateChannelNo(newNo);
    }, 1500);
  };

  const handlePlusMinusChannel = (type) => {
    // if (!qrcodeScanned || wait) return;
    if (wait) return;

    setWait(true);
    firebase
      .firestore()
      .collection("tv_remote")
      .doc(qrcodeValue)
      .get()
      .then((docSnap) => {
        if (docSnap.exists) {
          const { channel_no } = docSnap.data();

          if (type === "plus") {
            const newNo = Number(channel_no) + 1;
            setChannelNo(newNo);
            handleUpdateChannelNo(newNo);
          } else if (type === "minus") {
            const newNo = Number(channel_no) - 1;
            if (newNo === 0) return;

            setChannelNo(newNo);
            handleUpdateChannelNo(newNo);
          }
        }
      })
      .catch((err) => {
        setWait(false);
        console.log(err);
      });
  };

  // Control Buttons
  const handleControlKey = async (type) => {
    try {
      await firebase
        .firestore()
        .collection("tv_remote")
        .doc(qrcodeValue)
        .update({ control_key: type });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section>
      <div className="gif-remote">
        {/* {qrcodeScanned ? ( */}
        {loading ? (
          <div className="py-5 text-center">
            <h5>Please wait...</h5>
          </div>
        ) : (
          <div className="remote-cover">
            <div style={{ background: `url(${texture})` }} className="remote">
              {/* <div className="black-space" /> */}
              <div
                style={{ background: `url(${textureDark})` }}
                className="d-flex align-items-center p-4"
              >
                <div onClick={handlePowerOff}>
                  <MyIcon src={off} alt="off" w="12vw" h="6vh" />
                </div>
                <div onClick={handleResetScan} className="ms-2">
                  <MyIcon src={scan} alt="scan" w="8vw" h="5vh" />
                </div>
              </div>
              {/* <div className="black-space" /> */}
              <div className="white-space mt-2" />
              <div className="d-flex align-items-center justify-content-between px-4 py-3">
                {/* VOLUME */}
                <div className="text-center">
                  <p className="title">VOL</p>
                  <div
                    onClick={() => handleControlKey("VOL_UP")}
                    className="number"
                  >
                    <MyIcon src={plus} alt="plus" w="15px" h="15px" />
                  </div>
                  <div
                    onClick={() => handleControlKey("VOL_DOWN")}
                    className="number"
                  >
                    <MyIcon src={minus} alt="minus" w="15px" h="4px" />
                  </div>
                </div>
                {/* NAVIGATION */}
                <div className="nav-control">
                  <div
                    onClick={() => handleControlKey("GUIDE_UP")}
                    className="arrow top mx-auto"
                  >
                    <MyIcon src={triTop} alt="arrow" w="16px" h="22px" />
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div
                      onClick={() => handleControlKey("VOL_DOWN")}
                      className="arrow left"
                    >
                      <MyIcon src={triLeft} alt="arrow" w="20px" h="14px" />
                    </div>
                    <div
                      onClick={() => handleControlKey("GUIDE_OK")}
                      className="ok"
                    >
                      <p>OK</p>
                    </div>
                    <div
                      onClick={() => handleControlKey("VOL_UP")}
                      className="arrow right"
                    >
                      <MyIcon src={triRight} alt="arrow" w="20px" h="14px" />
                    </div>
                  </div>
                  <div
                    onClick={() => handleControlKey("GUIDE_DOWN")}
                    className="arrow bottom mx-auto"
                  >
                    <MyIcon src={triBottom} alt="arrow" w="16px" h="22px" />
                  </div>
                </div>
                {/* CHANNEL */}
                <div className="text-center">
                  <p className="title">CH</p>
                  <div
                    onClick={() => handlePlusMinusChannel("plus")}
                    className="number"
                  >
                    <MyIcon src={plus} alt="plus" w="15px" h="15px" />
                  </div>
                  <div
                    onClick={() => handlePlusMinusChannel("minus")}
                    className="number"
                  >
                    <MyIcon src={minus} alt="minus" w="15px" h="4px" />
                  </div>
                </div>
              </div>
              {/* GUIDE */}
              <div
                onClick={() => handleControlKey("GUIDE")}
                className="guide mx-auto"
              >
                <p>TV GUIDE</p>
              </div>
              {/* NUMBERS */}
              <div className="mx-5 px-5">
                <div className="d-flex align-items-center justify-content-between mx-3">
                  <div onClick={() => handleNoClick("1")} className="number">
                    <p>1</p>
                  </div>
                  <div onClick={() => handleNoClick("2")} className="number">
                    <p>2</p>
                  </div>
                  <div onClick={() => handleNoClick("3")} className="number">
                    <p>3</p>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mx-3">
                  <div onClick={() => handleNoClick("4")} className="number">
                    <p>4</p>
                  </div>
                  <div onClick={() => handleNoClick("5")} className="number">
                    <p>5</p>
                  </div>
                  <div onClick={() => handleNoClick("6")} className="number">
                    <p>6</p>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mx-3">
                  <div onClick={() => handleNoClick("7")} className="number">
                    <p>7</p>
                  </div>
                  <div onClick={() => handleNoClick("8")} className="number">
                    <p>8</p>
                  </div>
                  <div onClick={() => handleNoClick("9")} className="number">
                    <p>9</p>
                  </div>
                </div>
                <div
                  onClick={() => handleNoClick("0")}
                  className="number mx-auto"
                >
                  <p>0</p>
                </div>
              </div>
              {/* COLORS */}
              <MyIcon src={remoteBottom} w="100vw" />
            </div>
            {channelNo && <div className="channel-no">{`CH ${channelNo}`}</div>}
          </div>
        )}
        {/* ) : (
          <div>
            <QrReader
              delay={200}
              style={{
                height: "60vh",
                width: "100vw",
              }}
              onError={handleError}
              onScan={handleOnAppScan}
            />
            {qrcodeValue.length > 0 && (
              <h3 className="text-center text-white">{`Linked with ${qrcodeValue}`}</h3>
            )}
          </div>
        )} */}
      </div>
    </section>
  );
};

export default RemoteApp;
